import type { LocaleMessageBundle } from '../../types'
export const customerMessages: LocaleMessageBundle = {
  vi: {
    'customer.receiptCreateSuccess': 'Thu công nợ thành công.',
    'customer.title': 'Khách hàng',
    'customer.viewDetail': 'Xem chi tiết',
    'customer.groups': 'Nhóm khách hàng',
    'customer.tiers': 'Hạng thành viên',
    'customer.debts': 'Công nợ khách hàng',
    'customer.debtSearchPlaceholder': 'Nhập tên hoặc số điện thoại',
    'customer.receiptSearchPlaceholder': 'Nhập mã phiếu thu',
    'customer.create': 'Thêm khách hàng',
    'customer.update': 'Cập nhật khách hàng',
    'customer.quickCreate': 'Thêm nhanh khách hàng',
    'customer.dialog.createSubtitle': 'Thêm thông tin khách hàng vào hệ thống',
    'customer.dialog.updateSubtitle': 'Cập nhật thông tin khách hàng trong hệ thống',
    'customer.collect': 'Thu công nợ',
    'customer.receiptCode': 'Mã phiếu thu',
    'customer.receiptCancelTitle': 'Hủy phiếu thu',
    'customer.receiptCancelAction': 'Hủy',
    'customer.receiptCancelConfirm': 'Bạn có chắc muốn hủy phiếu thu {code}?',
    'customer.receiptCancelConfirmAction': 'Hủy',
    'customer.receiptCancelReason': 'Lý do hủy',
    'customer.viewCancelReason': 'Xem lý do hủy',
    'customer.cancelReasonTitle': 'Lý do hủy phiếu thu',
    'customer.receiptCancelSubtitle': 'Phiếu đã hủy không còn tính vào tổng',
    'customer.code': 'Mã khách hàng',
    'customer.name': 'Tên khách hàng',
    'customer.phone': 'Số điện thoại',
    'customer.email': 'Email',
    'customer.birthDate': 'Ngày sinh',
    'customer.address': 'Địa chỉ',
    'customer.group': 'Nhóm khách hàng',
    'customer.tier': 'Hạng thành viên',
    'customer.catalogCode': 'Mã nhóm khách hàng',
    'customer.tierCode': 'Mã hạng thành viên',
    'customer.groupName': 'Tên nhóm khách hàng',
    'customer.tierName': 'Tên hạng thành viên',
    'customer.sortOrder': 'Thứ tự',
    'customer.groupDialog.createTitle': 'Thêm nhóm khách hàng',
    'customer.groupDialog.updateTitle': 'Cập nhật nhóm khách hàng',
    'customer.groupDialog.createSubtitle': 'Thêm thông tin nhóm khách hàng vào hệ thống',
    'customer.groupDialog.updateSubtitle': 'Cập nhật thông tin nhóm khách hàng trong hệ thống',
    'customer.tierDialog.createTitle': 'Thêm hạng thành viên',
    'customer.tierDialog.updateTitle': 'Cập nhật hạng thành viên',
    'customer.tierDialog.createSubtitle': 'Thêm thông tin hạng thành viên vào hệ thống',
    'customer.tierDialog.updateSubtitle': 'Cập nhật thông tin hạng thành viên trong hệ thống',
    'customer.groupPlaceholders.code': 'Nhập mã nhóm khách hàng',
    'customer.groupPlaceholders.name': 'Nhập tên nhóm khách hàng',
    'customer.tierPlaceholders.code': 'Nhập mã hạng thành viên',
    'customer.tierPlaceholders.name': 'Nhập tên hạng thành viên',
    'customer.catalogPlaceholders.sortOrder': 'Nhập thứ tự',
    'customer.creditLimit': 'Hạn mức nợ',
    'customer.debt': 'Dư nợ',
    'customer.points': 'Điểm',
    'customer.totalPaid': 'Tổng tiền đã trả',
    'customer.targetAmount': 'Doanh số mục tiêu',
    'customer.invoiceCode': 'Mã hóa đơn',
    'customer.remaining': 'Còn lại',
    'customer.paid': 'Đã trả',
    'customer.transactionType': 'Loại giao dịch',
    'customer.debtBalance': 'Số dư công nợ',
    'customer.previousTier': 'Hạng trước',
    'customer.newTier': 'Hạng mới',
    'customer.noData': 'Chưa có dữ liệu',
    'customer.cashValue': 'Giá trị tiền',
    'customer.source': 'Chứng từ',
    'customer.pointsLedgerNoPermission': 'Bạn không có quyền xem chi tiết sổ điểm.',
    'customer.errors.invalidId': 'Mã khách hàng không hợp lệ.',
    'customer.errors.cancelReasonRequired': 'Vui lòng nhập lý do hủy.',
    'customer.errors.cancelReasonTooLong':
      'Lý do hủy không được vượt quá {max} ký tự.',
    'customer.pointTypes.earn': 'Tích điểm',
    'customer.pointTypes.redeem': 'Sử dụng điểm',
    'customer.pointTypes.refund': 'Hoàn điểm',
    'customer.pointTypes.manual_adjustment': 'Điều chỉnh thủ công',
    'customer.pointTypes.expire': 'Hết hạn điểm',
    'customer.debtTypes.invoice': 'Ghi nhận công nợ',
    'customer.debtTypes.invoice_cancellation': 'Hủy ghi nhận công nợ',
    'customer.debtTypes.receipt': 'Thu công nợ',
    'customer.debtTypes.receipt_cancellation': 'Hủy thu công nợ',
    'customer.debtTypes.sale_return': 'Khách trả hàng',
    'customer.debtTypes.sale_return_cancellation': 'Hủy khách trả hàng',
    'customer.sourceTypes.sales_invoice': 'Hóa đơn bán hàng',
    'customer.sourceTypes.customer_receipt': 'Thu công nợ',
    'customer.sourceTypes.manual': 'Điều chỉnh thủ công',
    'customer.pointReasons.completedInvoice': 'Hoàn thành hóa đơn bán hàng',
    'customer.pointReasons.pointPayment': 'Thanh toán bằng điểm',
    'customer.pointReasons.invoiceCancellation': 'Hủy hóa đơn bán hàng',
    'customer.tierReasons.recalculatedFromInvoice':
      'Tính lại hạng thành viên từ thanh toán hóa đơn',
    'customer.tierReasons.manual': 'Điều chỉnh thủ công',
    'customer.invoiceStatuses.completed': 'Hoàn tất',
    'customer.invoiceStatuses.cancelled': 'Đã hủy',
    'button.back': 'Quay lại',
    'customer.pointType': 'Loại',
    'customer.pointChange': 'Thay đổi',
    'customer.pointBalance': 'Số dư',
    'customer.reason': 'Lý do',
    'loyalty.title': 'Quản lý tích điểm thành viên',
    'loyalty.name': 'Tên chính sách',
    'loyalty.earningBasis': 'Cơ sở tích điểm',
    'loyalty.netInvoice': 'Giá trị hóa đơn ròng',
    'loyalty.netProduct': 'Giá trị sản phẩm ròng',
    'loyalty.earningUnit': 'Số tiền cho một đơn vị điểm',
    'loyalty.basePoints': 'Điểm trên một đơn vị',
    'loyalty.rounding': 'Cách làm tròn',
    'loyalty.floor': 'Làm tròn xuống',
    'loyalty.round': 'Làm tròn gần nhất',
    'loyalty.ceil': 'Làm tròn lên',
    'loyalty.redeemSection': 'Quy đổi điểm',
    'loyalty.pointUnit': 'Số điểm mỗi đơn vị quy đổi',
    'loyalty.cashPerUnit': 'Tiền mỗi đơn vị quy đổi',
    'loyalty.minimum': 'Điểm tối thiểu',
    'loyalty.allowPartial': 'Cho phép thanh toán một phần',
    'loyalty.earnOnRedeem': 'Vẫn tích điểm khi dùng điểm',
    'loyalty.example': 'Ví dụ hóa đơn 275.000đ sẽ nhận {points} điểm',
    'loyalty.activate': 'Kích hoạt',
    'loyalty.pause': 'Tạm dừng',
    'loyalty.saved': 'Đã lưu chính sách tích điểm',
    'customer.tendered': 'Tiền khách đưa',
    'customer.applied': 'Tiền cấn nợ',
    'customer.change': 'Tiền thối',
    'customer.outstandingInvoices': 'Các hóa đơn còn nợ',
    'customer.invoiceSelectionHint':
      'Chọn các khoản cần cấn nợ, tiền sẽ trừ vào các khoản đã chọn theo thứ tự cũ nhất trước. Bỏ chọn để loại khỏi đợt thu này.',
    'customer.noOutstandingInvoices': 'Không có hóa đơn đang nợ.',
    'customer.outstanding': 'Còn nợ',
    'customer.selectAll': 'Tất cả',
    'customer.default': 'Mặc định',
    'customer.defaultLocked': 'Cần chọn dữ liệu khác làm mặc định trước khi gỡ.',
    'customer.status': 'Trạng thái',
    'customer.statuses.posted': 'Hoàn thành',
    'customer.statuses.cancelled': 'Đã hủy',
    'customer.deleteTitle': 'Xóa khách hàng',
    'customer.deleteConfirm': 'Bạn có chắc muốn xóa khách hàng {name}?',
    'customer.errors.deleteFailed': 'Không thể xóa khách hàng. Vui lòng thử lại.',
    'customer.groupDeleteConfirm': 'Bạn có chắc muốn xóa nhóm khách hàng {name}?',
    'customer.tierDeleteConfirm': 'Bạn có chắc muốn xóa hạng thành viên {name}?',
    'customer.groupErrors.loadFailed': 'Không thể tải danh sách nhóm khách hàng.',
    'customer.groupErrors.saveFailed': 'Không thể lưu nhóm khách hàng. Vui lòng thử lại.',
    'customer.groupErrors.deleteFailed': 'Không thể xóa nhóm khách hàng. Vui lòng thử lại.',
    'customer.tierErrors.loadFailed': 'Không thể tải danh sách hạng thành viên.',
    'customer.tierErrors.saveFailed': 'Không thể lưu hạng thành viên. Vui lòng thử lại.',
    'customer.tierErrors.deleteFailed': 'Không thể xóa hạng thành viên. Vui lòng thử lại.',
    'customer.overview': 'Tổng quan',
    'customer.invoices': 'Hóa đơn',
    'customer.ledger': 'Sổ công nợ',
    'customer.tierHistory': 'Lịch sử hạng',
    'customer.date': 'Ngày',
    'customer.amount': 'Số tiền',
    'customer.placeholders.code': 'Nhập mã khách hàng',
    'customer.placeholders.name': 'Nhập tên khách hàng',
    'customer.placeholders.phone': 'Nhập số điện thoại',
    'customer.placeholders.email': 'Nhập email',
    'customer.placeholders.address': 'Nhập địa chỉ',
    'customer.placeholders.group': 'Chọn nhóm khách hàng',
    'customer.placeholders.tier': 'Chọn hạng thành viên',
    'customer.placeholders.creditLimit': 'Nhập hạn mức nợ',
  },
  en: {
    'customer.receiptCreateSuccess': 'Debt collection completed successfully.',
    'customer.title': 'Customers',
    'customer.viewDetail': 'View details',
    'customer.groups': 'Customer groups',
    'customer.tiers': 'Membership tiers',
    'customer.debts': 'Customer receivables',
    'customer.debtSearchPlaceholder': 'Enter name or phone number',
    'customer.receiptSearchPlaceholder': 'Enter receipt code',
    'customer.create': 'Add customer',
    'customer.update': 'Update customer',
    'customer.quickCreate': 'Quick add customer',
    'customer.dialog.createSubtitle': 'Add customer information to the system',
    'customer.dialog.updateSubtitle': 'Update customer information in the system',
    'customer.collect': 'Collect debt',
    'customer.receiptCode': 'Receipt code',
    'customer.receiptCancelTitle': 'Cancel receipt',
    'customer.receiptCancelAction': 'Cancel receipt',
    'customer.receiptCancelConfirm': 'Are you sure you want to cancel receipt {code}?',
    'customer.receiptCancelConfirmAction': 'Cancel',
    'customer.receiptCancelReason': 'Cancellation reason',
    'customer.viewCancelReason': 'View cancellation reason',
    'customer.cancelReasonTitle': 'Receipt cancellation reason',
    'customer.receiptCancelSubtitle': 'Cancelled receipts are excluded from totals',
    'customer.code': 'Customer code',
    'customer.name': 'Customer name',
    'customer.phone': 'Phone',
    'customer.email': 'Email',
    'customer.birthDate': 'Birth date',
    'customer.address': 'Address',
    'customer.group': 'Customer group',
    'customer.tier': 'Membership tier',
    'customer.catalogCode': 'Customer group code',
    'customer.tierCode': 'Membership tier code',
    'customer.groupName': 'Customer group name',
    'customer.tierName': 'Membership tier name',
    'customer.sortOrder': 'Sort order',
    'customer.groupDialog.createTitle': 'Add customer group',
    'customer.groupDialog.updateTitle': 'Update customer group',
    'customer.groupDialog.createSubtitle': 'Add customer group information to the system',
    'customer.groupDialog.updateSubtitle': 'Update customer group information in the system',
    'customer.tierDialog.createTitle': 'Add membership tier',
    'customer.tierDialog.updateTitle': 'Update membership tier',
    'customer.tierDialog.createSubtitle': 'Add membership tier information to the system',
    'customer.tierDialog.updateSubtitle': 'Update membership tier information in the system',
    'customer.groupPlaceholders.code': 'Enter customer group code',
    'customer.groupPlaceholders.name': 'Enter customer group name',
    'customer.tierPlaceholders.code': 'Enter membership tier code',
    'customer.tierPlaceholders.name': 'Enter membership tier name',
    'customer.catalogPlaceholders.sortOrder': 'Enter sort order',
    'customer.creditLimit': 'Credit limit',
    'customer.debt': 'Debt balance',
    'customer.points': 'Points',
    'customer.totalPaid': 'Total paid',
    'customer.targetAmount': 'Target amount',
    'customer.invoiceCode': 'Invoice code',
    'customer.remaining': 'Remaining',
    'customer.paid': 'Paid',
    'customer.transactionType': 'Transaction type',
    'customer.debtBalance': 'Debt balance',
    'customer.previousTier': 'Previous tier',
    'customer.newTier': 'New tier',
    'customer.noData': 'No data',
    'customer.cashValue': 'Cash value',
    'customer.source': 'Source',
    'customer.pointsLedgerNoPermission': 'You do not have permission to view the point ledger.',
    'customer.errors.invalidId': 'Invalid customer ID.',
    'customer.errors.cancelReasonRequired': 'Cancellation reason is required.',
    'customer.errors.cancelReasonTooLong':
      'Cancellation reason cannot exceed {max} characters.',
    'customer.pointTypes.earn': 'Earn',
    'customer.pointTypes.redeem': 'Redeem',
    'customer.pointTypes.refund': 'Refund',
    'customer.pointTypes.manual_adjustment': 'Manual adjustment',
    'customer.pointTypes.expire': 'Expired',
    'customer.debtTypes.invoice': 'Invoice debt',
    'customer.debtTypes.invoice_cancellation': 'Invoice cancellation',
    'customer.debtTypes.receipt': 'Debt receipt',
    'customer.debtTypes.receipt_cancellation': 'Receipt cancellation',
    'customer.debtTypes.sale_return': 'Customer return',
    'customer.debtTypes.sale_return_cancellation': 'Customer return cancellation',
    'customer.sourceTypes.sales_invoice': 'Sales invoice',
    'customer.sourceTypes.customer_receipt': 'Customer receipt',
    'customer.sourceTypes.manual': 'Manual adjustment',
    'customer.pointReasons.completedInvoice': 'Completed invoice',
    'customer.pointReasons.pointPayment': 'Point payment',
    'customer.pointReasons.invoiceCancellation': 'Invoice cancellation',
    'customer.tierReasons.recalculatedFromInvoice':
      'Membership tier recalculated from completed invoice payments',
    'customer.tierReasons.manual': 'Manual adjustment',
    'customer.invoiceStatuses.completed': 'Completed',
    'customer.invoiceStatuses.cancelled': 'Cancelled',
    'button.back': 'Back',
    'customer.pointType': 'Type',
    'customer.pointChange': 'Change',
    'customer.pointBalance': 'Balance',
    'customer.reason': 'Reason',
    'loyalty.title': 'Member loyalty points',
    'loyalty.name': 'Policy name',
    'loyalty.earningBasis': 'Earning basis',
    'loyalty.netInvoice': 'Net invoice amount',
    'loyalty.netProduct': 'Net product amount',
    'loyalty.earningUnit': 'Amount per point unit',
    'loyalty.basePoints': 'Points per unit',
    'loyalty.rounding': 'Rounding mode',
    'loyalty.floor': 'Floor',
    'loyalty.round': 'Round',
    'loyalty.ceil': 'Ceil',
    'loyalty.redeemSection': 'Point redemption',
    'loyalty.pointUnit': 'Redeem point unit',
    'loyalty.cashPerUnit': 'Cash per redeem unit',
    'loyalty.minimum': 'Minimum points',
    'loyalty.allowPartial': 'Allow partial payment',
    'loyalty.earnOnRedeem': 'Earn points when redeeming',
    'loyalty.example': 'A 275,000 invoice earns {points} points',
    'loyalty.activate': 'Activate',
    'loyalty.pause': 'Pause',
    'loyalty.saved': 'Loyalty policy saved',
    'customer.tendered': 'Tendered',
    'customer.applied': 'Applied to debt',
    'customer.change': 'Change due',
    'customer.outstandingInvoices': 'Outstanding invoices',
    'customer.invoiceSelectionHint':
      'Pick the items to settle; the tendered amount is applied to the selected items oldest first. Uncheck an item to exclude it.',
    'customer.noOutstandingInvoices': 'No outstanding invoices.',
    'customer.outstanding': 'Outstanding',
    'customer.selectAll': 'All',
    'customer.default': 'Default',
    'customer.defaultLocked': 'Set another record as default before clearing this one.',
    'customer.status': 'Status',
    'customer.statuses.posted': 'Completed',
    'customer.statuses.cancelled': 'Cancelled',
    'customer.deleteTitle': 'Delete customer',
    'customer.deleteConfirm': 'Are you sure you want to delete customer {name}?',
    'customer.errors.deleteFailed': 'Unable to delete customer. Please try again.',
    'customer.groupDeleteConfirm': 'Are you sure you want to delete customer group {name}?',
    'customer.tierDeleteConfirm': 'Are you sure you want to delete membership tier {name}?',
    'customer.groupErrors.loadFailed': 'Unable to load customer groups.',
    'customer.groupErrors.saveFailed': 'Unable to save customer group. Please try again.',
    'customer.groupErrors.deleteFailed': 'Unable to delete customer group. Please try again.',
    'customer.tierErrors.loadFailed': 'Unable to load membership tiers.',
    'customer.tierErrors.saveFailed': 'Unable to save membership tier. Please try again.',
    'customer.tierErrors.deleteFailed': 'Unable to delete membership tier. Please try again.',
    'customer.overview': 'Overview',
    'customer.invoices': 'Invoices',
    'customer.ledger': 'Debt ledger',
    'customer.tierHistory': 'Tier history',
    'customer.date': 'Date',
    'customer.amount': 'Amount',
    'customer.placeholders.code': 'Enter customer code',
    'customer.placeholders.name': 'Enter customer name',
    'customer.placeholders.phone': 'Enter phone number',
    'customer.placeholders.email': 'Enter email',
    'customer.placeholders.address': 'Enter address',
    'customer.placeholders.group': 'Select customer group',
    'customer.placeholders.tier': 'Select membership tier',
    'customer.placeholders.creditLimit': 'Enter credit limit',
  },
}
